import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import classNames from "classnames";
import * as Yup from "yup";
import { InputText } from "primereact/inputtext";
import { handlePostRequest } from "../../services/PostTemplate";
import { useHistory } from "react-router-dom";

const SearchDevice = ({ handleReturnData, title, api }) => {

    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("");
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [otpLimitText, setOtpLimitText] = useState("");

    let history = useHistory();

    useEffect(() => {
        // Check localStorage on component mount to see if button should be disabled
        const clickData = JSON.parse(localStorage.getItem("deviceManagerSearchOtpLimit")) || {};
        const { clicks, timestamp } = clickData;
        const now = new Date().getTime();

        if (clicks >= 4 && timestamp && now - timestamp < 120000) {
            setIsButtonDisabled(true);
            const remainingTime = 120000 - (now - timestamp);
            setTimeout(() => resetClicks(), remainingTime);
        } else {
            resetClicks();
        }
    }, []);

    const resetClicks = () => {
        setIsButtonDisabled(false);
        setOtpLimitText("")
        localStorage.removeItem("deviceManagerSearchOtpLimit");
    };

    const handleButtonClick = () => {
        const clickData = JSON.parse(localStorage.getItem("deviceManagerSearchOtpLimit")) || { clicks: 0, timestamp: 0 };
        let { clicks } = clickData;
        clicks += 1;

        if (clicks > 3) {
            setIsButtonDisabled(true);
            localStorage.setItem("deviceManagerSearchOtpLimit", JSON.stringify({ clicks, timestamp: new Date().getTime() }));
            setOtpLimitText("Too many wrong attemps! Please try after 2mins.")
            setTimeout(() => resetClicks(), 120000); // 2-minute timer
        } else {
            localStorage.setItem("deviceManagerSearchOtpLimit", JSON.stringify({ clicks, timestamp: clickData.timestamp }));
        }
    };

    const validationSchema = Yup.object().shape({
        MobileNo: Yup.string().required("This field is required.").min(11).max(11),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            MobileNo: "",
        },
        onSubmit: async (data) => {
            data["Reserved1"] = ""
            try {
                setloading(true);
                setloadingIcon("pi pi-spin pi-spinner");
                const res = await handlePostRequest(data, api);
                handleReturnData(res?.data);
                console.log('res?.data', res?.data)
            } catch (error) {
                console.log('error', error)
                if (error.response.data.responsecode == 0)
                    handleReturnData(null);
            }
            finally {
                setloading(false);
                setloadingIcon("pi pi-save");
            }
        },
    });
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };
    return (
        <div>
            <div className="page_header">
                <div className="Top__Btn" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <div className="d_align">
                        <i className="pi pi-arrow-circle-left mr-1" onClick={() => history.goBack()} />
                        <h3 className="mod_heading">{title}</h3>
                    </div>
                </div>
            </div>
            <div className="card Card__Round">
                <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                    <div className="p-fluid p-formgrid p-grid">
                        <div className="p-field p-col-12 p-md-6">
                            <div className="p-field input_cp">
                                <label htmlFor="MobileNo" className={classNames({ "p-error": isFormFieldValid("MobileNo") }, "Label__Text")}>
                                    Mobile Number<span className="Label__Required">*</span>
                                </label>
                                <InputText id="MobileNo" placeholder="" name="MobileNo" value={formik?.values?.MobileNo} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("MobileNo") }, "input_text")} keyfilter={/^[0-9]+$/} />

                                {getFormErrorMessage("MobileNo")}
                            </div>
                        </div>
                    </div>

                    <div className="GenerateDown__Btn p-mt-4" style={{ textAlign: "left" }}>
                        <Button disabled={loading} icon={loadingIcon || ""} iconPos="right" label={"Search"} className="Btn__Transparent" />
                    </div>
                    <small className="p-mt-4" style={{ display: "block", color: "red" }}>
                        {otpLimitText && otpLimitText}
                    </small>
                </form>
            </div>
        </div>
    );
};

export default SearchDevice;
